
export function getUrlSearchParams() {
    const queryString = window.location.search;
    return new URLSearchParams(queryString);
}
export function getUrlSearchParamsObject() {
    const params = {}
    for (const [key, value] of getUrlSearchParams()) {
        params[key] = value
    }
    return params
}

export function getWebsiteUrl() {

    const element = document.querySelector('kaart-viewer')
    if(element.getAttribute('url')) {
        return element.getAttribute('url')
    }

    if(window.location.origin === 'http://localhost:3000') {
        return 'http://localhost:3000'
        // return 'http://localhost/phpstormprojects/geonovation/beta/kaartviewer'
    }

    let pathName = window.location.pathname.replace('/kaartviewer/index.html', '')

    pathName = pathName.replace('index.php', '')

    let res = pathName.charAt(pathName.length - 1);
    if(res === '/') {
        pathName = pathName.slice(0, -1);
    }

    return window.location.origin + pathName
}

export function getWebsiteName() {
    const urlParams = getUrlSearchParams()

    let websiteName = urlParams.get('website')
    if(websiteName === null) {

        urlParams.forEach( (key, param)  => {
            if(key === '') {
                websiteName = param.replace('@', '');
            }
        })

        if(websiteName === null) {
            websiteName = 'testbookmark'
        }
    }

    const element = document.querySelector('kaart-viewer')
    if(element.getAttribute('website')) {
        websiteName = element.getAttribute('website')
    }

    return websiteName
}

export function isValidUrl(urlString) {

    try {
        new URL(urlString);
        return true;
    } catch (err) {
        return false;
    }

    // const urlPattern = new RegExp('^(https?:\\/\\/)?'+ // validate protocol
    //     '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|'+ // validate domain name
    //     '((\\d{1,3}\\.){3}\\d{1,3}))'+ // validate OR ip (v4) address
    //     '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*'+ // validate port and path
    //     '(\\?[;&a-z\\d%_.~+=-]*)?'+ // validate query string
    //     '(\\#[-a-z\\d_]*)?$','i'); // validate fragment locator
    // return !!urlPattern.test(urlString);
}
